import r from "../managers/braze-instance.js";
import InAppMessage from "./models/in-app-message.js";
import se from "./in-app-message-manager-factory.js";
import { logInAppMessageImpression } from "./log-in-app-message-impression.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as sr } from "../common/constants.js";
import { logger as N, EventTypes as d } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageClick(o) {
  if (!r.rr()) return !1;
  if (!(o instanceof InAppMessage)) return N.error(sr), !1;
  const s = se.ea().ut(o, d.Fi);
  if (s) {
    o.Ur() || logInAppMessageImpression(o);
    for (let r = 0; r < s.$e.length; r++)
      rt.m().Ce(ot.Qr, [o.triggerId], s.$e[r]);
  }
  return s.tt;
}
